import React, { useCallback, useMemo } from "react";
import AnimateHeight from "react-animate-height";
import { AllocationMatrixGuest } from "services/BookingManagerApi/types/AllocationsResponse";
import Checkbox from "ui/Checkbox";
import { DetailsLink } from "ui/DetailsLink";

interface Props {
  guests: AllocationMatrixGuest[];
  filteredGuestIds: string[];
  setFilteredGuestIds: React.Dispatch<React.SetStateAction<string[]>>;
  isLatestVersion: boolean;
}

export const GuestAllocationFilter: React.FC<Props> = ({
  guests,
  filteredGuestIds,
  setFilteredGuestIds,
  isLatestVersion,
}) => {
  const [showFilter, setShowFilter] = React.useState(false);

  const handleShowFilter = useCallback(() => {
    setShowFilter((val) => !val);
  }, []);

  const handleCheckboxChange = useCallback((guestId: string) => {
    setFilteredGuestIds((prev: string[]) =>
      prev.includes(guestId)
        ? prev.filter(id => id !== guestId)
        : [...prev, guestId]
    );
  }, []);

  const contentHeight = useMemo(() => (showFilter ? 'auto' : 0), [showFilter]);

  if (!isLatestVersion) {
    return null;
  }

  return (
    <>
      <DetailsLink text="See Guest Filter" isOpen={showFilter} onClick={handleShowFilter} />
      <AnimateHeight className="animate-height" duration={300} height={contentHeight}>
        <div className="booking-filter p-15px bg-ivory mt-15px rounded">
          <div className="text-17px font-pt-sans font-normal mb-[15px]">Guests Filter</div>
          <div className="flex gap-[20px] flex-wrap">
            {guests.map((guest) => (
              <label key={guest.uuid} className="flex items-center gap-2">
                <Checkbox
                  checked={filteredGuestIds.includes(guest.uuid)}
                  onChange={() => handleCheckboxChange(guest.uuid)}
                  wrapperClassName="inline-flex"
                />
                <span className="font-pt-sans text-[15px] font-normal">{guest.name} {guest.isLeadGuest && <span className="text-status-enquiry text-[13px] italic">Lead</span>}</span>
              </label>))}
          </div>
        </div>
      </AnimateHeight>
    </>
  );
};